import * as React from 'react';
const { useCallback, useRef } = React;
import Typography from '@seeneco-ui/core/components/typography';
import Button from '@seeneco-ui/core/components/button';
import ActionScreen from '@seeneco-ui/core/components/action-screen';
import Box from '@seeneco-ui/core/components/box';
import {
	Form,
	FormTextField,
	FormRef,
	FormFundsRegisterNumberTextField,
} from '@seeneco-ui/core/components/form';
import Spinner from '@seeneco-ui/core/components/spinner';
import FormHelpers from '@seeneco-ui/core/components/form-helpers';

import {
	FormLayout,
} from './styled';


type ContactDataProps = {
	isFetching: boolean;
	tenant: Tenant;
	onUpdateTenant: (tenant: Tenant) => void;
};

const PayeeRequsites: React.SFC<ContactDataProps> = (props) => {
	const {
		isFetching,
		tenant,
		onUpdateTenant,
	} = props;
	const formRef = useRef<FormRef>(null);
	const handleSave = useCallback(() => formRef.current && formRef.current.submitForm(), [formRef.current]);
	const handleReset = useCallback(() => formRef.current && formRef.current.resetForm(), [formRef.current]);
	const handleUpdateTenant = useCallback((formObject: Tenant) => onUpdateTenant(formObject), []);

	const renderForm = () => {
		return (
			<Form
				ref={formRef as React.LegacyRef<any>}
				formObject={tenant}
				isFetching={isFetching}
				onSubmit={handleUpdateTenant}>
				<Box width='100%' marginBottom='40px'>
					<FormHelpers.FormTitle fullWidth>Компания</FormHelpers.FormTitle>
					<FormTextField
						name={['LegalData', 'LegalName']}
						label='Наименование юридического лица'
						placeholder='ООО «Ромашка»'
						fullWidth
						required
					/>
					<FormTextField
						name={['LegalData', 'LegalAddress']}
						label='Юридический адрес'
						placeholder='Введите юридический адрес'
						fullWidth
						required
					/>
					<Box width='100%' display='flex'>
						<Box width='33.33%' marginRight='20px'>
							<FormTextField
								name={['LegalData', 'TaxReferenceNumber']}
								label='ИНН'
								placeholder='7720XXXXX1'
								fullWidth
								required
							/>
						</Box>
						<Box width='33.33%' marginRight='20px'>
							<FormTextField
								name={['LegalData', 'StateRegNumber']}
								label='ОГРН'
								placeholder='111774635XXX8'
								fullWidth
								required
							/>
						</Box>
						<Box width='33.33%'>
							<FormTextField
								name={['LegalData', 'TaxRegReasonCode']}
								label='КПП'
								placeholder='7720XXXXX1'
								fullWidth
								required
							/>
						</Box>
					</Box>
				</Box>
				<Box width='100%'>
					<FormHelpers.FormTitle fullWidth>Расчетный счет</FormHelpers.FormTitle>
					<FormTextField
						name={['LegalData', 'SettlementAccountNumber']}
						label='Номер расчётного счета'
						placeholder='40702810XXXXXXXX1234'
						fullWidth
						required
					/>
					<FormTextField
						name={['LegalData', 'BankName']}
						label='В банке'
						placeholder='Например, ОАО «Банк»'
						fullWidth
						required
					/>
					<FormTextField
						name={['LegalData', 'BankBIC']}
						label='БИК'
						placeholder='0445XXX93'
						fullWidth
						required
					/>
					<FormFundsRegisterNumberTextField
						name={['LegalData', 'BankCorrAccNumber']}
						label='Номер корр. счёта'
						placeholder='30101 810 X XXXX0000123'
						fullWidth
						required
					/>
				</Box>
			</Form>
		);
	};

	return (
		<ActionScreen.Base
			renderHeader={(props) => (
				<ActionScreen.Header {...props}>
					<Typography.Title>Реквизиты плательщика</Typography.Title>
				</ActionScreen.Header>
			)}
			renderFooter={() => (
				<ActionScreen.Footer>
					<Button onClick={handleSave}>Сохранить</Button>
					<Button color='default' onClick={handleReset}>Отмена</Button>
				</ActionScreen.Footer>
			)}>
			{
				isFetching
				?	<Box
						width='100%'
						minHeight='300px'
						display='flex'
						justifyContent='center'
						alignItems='center'>
						<Spinner />
					</Box>
				: 
				<FormLayout>
					{renderForm()}
				</FormLayout>
			}
		</ActionScreen.Base>
	);
}

PayeeRequsites.displayName = 'PayeeRequsites';
PayeeRequsites.defaultProps = {};

export default PayeeRequsites;
